module.exports = __webpack_public_path__ + "static/media/feather.c3dfc80c.svg";